<!-- Bottone toggle -->
<button 
  (click)="isOpen = !isOpen"
  class="fixed top-4 right-4 bg-[#520909] hover:bg-red-600 text-white p-2 cursor-pointer rounded-lg shadow-lg z-[10000] transition-colors duration-200">
  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path *ngIf="!isOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    <path *ngIf="isOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
  </svg>
</button>

<div 
  *ngIf="isOpen"
  class="fixed top-16 right-4 border-2 border-[#F3F4F6] rounded-xl p-4 shadow-md bg-white z-[9999]
         w-max min-w-[200px]
         xl:text-sm
         2xl:text-md 3xl:text-lg 4xl:text-xl 5xl:text-2xl
         xs:p-3 sm:p-3 md:p-4 lg:p-5 xl:p-5
         2xl:p-6 3xl:p-7 4xl:p-8 5xl:p-9
         xs:min-w-[180px] sm:min-w-[190px] md:min-w-[200px] lg:min-w-[220px] xl:min-w-[240px]
         2xl:min-w-[270px] 3xl:min-w-[300px] 4xl:min-w-[330px] 5xl:min-w-[360px]
         animate-in slide-in-from-right-2 fade-in duration-200">
         
  <h2 class="font-semibold text-red-600 mb-2 text-center
              xl:text-sm
         2xl:text-md 3xl:text-lg 4xl:text-xl 5xl:text-2xl">Live Screen Size</h2>
             
  <div class="grid grid-cols-2 gap-x-4 gap-y-2
              xs:gap-x-2 xs:gap-y-1 sm:gap-x-3 sm:gap-y-1 md:gap-x-4 md:gap-y-2">
    <span class="font-medium text-gray-700">Width:</span>
    <span class="font-mono text-right">{{ width }}px</span>

    <span class="font-medium text-gray-700">Height:</span>
    <span class="font-mono text-right">{{ height }}px</span>

    <span class="font-medium text-gray-700">Breakpoint:</span>
    <span class="font-mono text-right">{{ getBreakpoint() }}</span>

    <span class="font-medium text-gray-700">Tailwind Class:</span>
    <span class="font-mono text-right">{{ getTailwindClass() }}</span>
  </div>
</div>